<div>
    <span class="text-info clickeable" tooltip="Ver Detalles del Lote" (click)="viewBatch()">
        <i class="fa fa-eye" *ngIf="!loading"></i>
        <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span>
    </span>
</div>

<app-modal-dialog [show]="showModal" (closed)="closeModalEmit()"  size="xl" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Detalle de Lote</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>
    <div class="modal-body" modal-body *ngIf="batchData!=null">
        <ng-container>
            <div class="row border border-1 py-4">
                <div class="row mb-4">
                    <div class="col-sm-auto">
                        Fecha de Validación: <span class="font-bold" >{{batchData.validationResults.validationDate | date:'dd-MM-YYYY HH:mm'}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-auto mb-3">
                        <div *ngIf="status(batchData.validationResults.status)" class="d-flex align-items-center gap-2">
                            
                            <!-- Badge -->
                            <span class="badge bg-primary">
                                {{ status(batchData.validationResults.status).name }}
                            </span>

                            <!-- Description -->
                            <span class="text-muted">
                                {{ status(batchData.validationResults.status).description }}
                            </span>

                        </div>

                        <div *ngIf="!status(batchData.validationResults.status)">
                            <span class="text-danger">Estado desconocido</span>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>
        <ng-container *ngIf="batchData.records">
            <div class="row border border-1 py-4" *ngFor="let item of batchData.records">
                <div class="row mb-4">
                    <div class="col-sm-6">
                        Resultado: <span class="font-bold" >{{item.validationResult}}</span>
                    </div>
                    <div class="col-sm-6">
                        Moneda: <span class="font-bold" >{{item.currency}}</span>
                    </div>
                    <div class="col-sm-6">
                        Producto: <span class="font-bold" >{{item.productNumber}}</span>
                    </div>
                    <div class="col-sm-6">
                        Tipo: <span class="font-bold" *ngIf="statusType(item.productType)">
                            {{ statusType(item.productType) }}
                        </span>
                        <span class="font-bold" *ngIf="!statusType(item.productType)">
                            {{item.productType}}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</app-modal-dialog>